/* eslint-disable import/named */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useRef, useState} from 'react';
import ReactPaginate from 'react-paginate';
import {format} from 'date-fns';
import {confirmAlert} from 'react-confirm-alert';
import {toast} from 'react-toastify';

import ModalGxRxSessionViewJson from 'pages/ModalGxRxSessionViewJson';
import type {GxSession} from 'interfaces';

import 'react-confirm-alert/src/react-confirm-alert.css';

const LIMIT = Number(process.env.REACT_APP_PAGINATE_LIMIT || 10);

type TProps = {
	dataSession: GxSession[] | any;
	title: string;
	deleteSession: (id: string) => void;
};
type TData = {
	selected: number;
};
const SessionTableRx = ({dataSession, title = '', deleteSession}: TProps) => {
	const [show, setShow] = useState(false);
	const titleRef = useRef(title);
	const [modelGxSession, setModelGxSession] = useState<GxSession>();
	// paginate only front
	const [pageCount, setPageCount] = useState(0);
	const [page, setPage] = useState(0);
	const startIndex = page * LIMIT;
	const endIndex = startIndex + LIMIT;

	const pageArray = dataSession?.slice(startIndex, endIndex);

	const handleShow = () => setShow(true);

	const editGxRxSessions = (modelSessionTable: GxSession) => {
		handleShow();
		setModelGxSession({...modelSessionTable});
	};

	const handlePageClick = ({selected}: TData) => {
		const currentPage = selected;

		setPage(currentPage);
		setPageCount(Math.ceil(dataSession?.length / LIMIT));
	};

	/* Setting the pageCount to the ceiling of the totalPolicies divided by the limit. */
	useEffect(
		() => setPageCount(Math.ceil(dataSession?.length / LIMIT)),
		[dataSession],
	);

	/**
	 * It returns an object with the properties that the modal component needs to render
	 * @param {Policy} item - Policy - The item that is being passed to the modal.
	 */
	const optionsRemoveModal = (item: GxSession) => ({
		title: 'Do you really want to remove this item?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					deleteSession(item.diameterSessionId || '-');
					toast.info('Delete order sent');
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	/**
	 * A function that takes in a Policy object and returns a function that calls the confirmAlert
	 * function with the optionsRemoveModal function.
	 * @param {Policy} item - Policy - this is the item that is being passed to the function.
	 */
	const handleRemove = (item: GxSession) =>
		confirmAlert(optionsRemoveModal(item));

	return (
		<div className="panel-body">
			<div className="col-md-12 mt-4 ">
				{' '}
				<div className="table-responsive h500 mt-2">
					{pageArray?.length > 0 ? (
						<>
							<table className="table table-striped table-sm table-head-fixed text-nowrap">
								<thead>
									<tr>
										<th className="col-1">Session Id</th>
										<th className="col-1">Origin Host</th>
										<th className="col-3">Origin Realm</th>
										<th className="col-1">SUPI</th>
										<th className="col-1">IP v4</th>
										<th className="col-1">IP v6</th>
										<th className="col-1">GPSI</th>
										<th className="col-1">DNN</th>
										<th className="col-1">Create Time</th>
										<th className="col-2">Actions</th>
									</tr>
								</thead>
								{pageArray.map((item: GxSession, key: number) => (
									<tbody key={key}>
										<tr>
											<td>{item.diameterSessionId || '-'}</td>
											<td>{item.diameterOriginHost || '-'}</td>
											<td>{item.diameterOriginRealm || '-'}</td>
											<td>{item.supi || '-'}</td>
											<td>{item.ipv4Address || '-'}</td>
											<td>{item.ipv6Address || '-'}</td>
											<td>{item.gpsi || '-'}</td>
											<td>{item.dnn || '-'}</td>
											<td>
												{item?.createDate
													? format(
															new Date(item?.createDate),
															'yyyy/MM/dd HH:MM:ss',
													  )
													: '-'}
											</td>

											<td>
												<button
													className="border-0 bg-transparent d-inline"
													onClick={() => {
														editGxRxSessions(item as never);
													}}>
													<i
														className="bi-1 bi-eye"
														title="Edit"
														data-toggle="tooltip"
													/>
												</button>

												<button
													className="border-0 bg-transparent d-inline"
													onClick={() => handleRemove(item)}>
													<i
														className="bi-1 bi-trash-fill text-danger"
														title=""
														data-toggle="tooltip"
														data-original-title="Delete"
													/>
												</button>
											</td>
										</tr>
									</tbody>
								))}
							</table>

							<ReactPaginate
								previousLabel="Previous"
								nextLabel="Next"
								breakLabel="..."
								pageCount={pageCount}
								marginPagesDisplayed={2}
								pageRangeDisplayed={2}
								onPageChange={handlePageClick as never}
								containerClassName="pagination justify-content-center"
								pageClassName="page-item"
								pageLinkClassName="page-link"
								previousClassName="page-item"
								previousLinkClassName="page-link"
								nextClassName="page-item"
								nextLinkClassName="page-link"
								breakClassName="page-item"
								breakLinkClassName="page-link"
								activeClassName="active"
							/>
						</>
					) : (
						<div className="text-center">
							<span className="h6">No data</span>
						</div>
					)}
				</div>
				<div>
					<div>
						<ModalGxRxSessionViewJson
							modelGxSession={modelGxSession}
							show={show}
							setShow={setShow}
							title={titleRef.current}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SessionTableRx;
